
export const OPEN_RECORD_KEY = "cardiolyse.record.open";

export type RecordFetchKind = "next" | "assign" | "resume";

export type RecordFetchInput = {
    recordId: string | undefined
    resumeInProgress: boolean
    openedRecordId: string | null
};

/**
 * @param input
 */
export function recordFetchKind(input: RecordFetchInput): RecordFetchKind {
    const {recordId, resumeInProgress, openedRecordId} = input;

    if (typeof recordId === "undefined") {
        return "next"
    }

    if (openedRecordId === recordId) {
        return "resume"
    }

    return resumeInProgress ? "resume" : "assign"
}

export function readOpenRecordId(): string | null {
    try {
        return window.sessionStorage.getItem(OPEN_RECORD_KEY)
    } catch (e) {
        return null
    }
}

/**
 * @param recordId
 */
export function writeOpenRecordId(recordId: string | undefined): void {
    try {
        if (typeof recordId === "undefined") {
            window.sessionStorage.removeItem(OPEN_RECORD_KEY)

            return
        }

        window.sessionStorage.setItem(OPEN_RECORD_KEY, recordId)
    } catch (e) {
    }
}

export function clearOpenRecordId(): void {
    try {
        window.sessionStorage.removeItem(OPEN_RECORD_KEY)
    } catch (e) {
    }
}
